import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex flex-column gap-4 sm-fs-xxs" }, [
    /*#__PURE__*/_createElementVNode("span", null, "I hereby certify that the :"),
    /*#__PURE__*/_createElementVNode("span", null, " (i) expenses claimed have not been reimbursed, and are not reimbursable, under any other health plan coverage; "),
    /*#__PURE__*/_createElementVNode("span", null, " (ii) the expenses claimed are medical expenses as defined by the Internal Revenue Service; "),
    /*#__PURE__*/_createElementVNode("span", null, " (iii) effective 01/01/2017 - any dependent for whom I am seeking reimbursement is enrolled in an employer or union sponsored group health plan that provides minimum value; "),
    /*#__PURE__*/_createElementVNode("span", null, " (iv) for any claim for reimbursement of health plan premiums, I paid for such premium on a post-tax basis (e.g., not through a pre-tax flex spending account); ")
  ])
], -1)
const _hoisted_2 = { class: "d-flex align-items-end justify-content-between gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CheckBox, {
        label: "By checking this box you are certifying that you have read, understood and agree to the conditions\n                listed herein.",
        className: "alert-checkbox text-large",
        modelValue: _ctx.agree,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agree) = $event)),
        id: "agree"
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}